var map = {
	"./virtual-bg1.png": 84,
	"./virtual-bg10.png": 85,
	"./virtual-bg11.png": 86,
	"./virtual-bg12.png": 87,
	"./virtual-bg13.png": 88,
	"./virtual-bg14.png": 89,
	"./virtual-bg15.png": 90,
	"./virtual-bg16.png": 91,
	"./virtual-bg17.png": 92,
	"./virtual-bg18.png": 93,
	"./virtual-bg19.png": 94,
	"./virtual-bg2.png": 95,
	"./virtual-bg20.png": 96,
	"./virtual-bg21.png": 97,
	"./virtual-bg22.png": 98,
	"./virtual-bg23.png": 99,
	"./virtual-bg24.png": 100,
	"./virtual-bg25.png": 101,
	"./virtual-bg3.png": 102,
	"./virtual-bg4.png": 103,
	"./virtual-bg5.png": 104,
	"./virtual-bg6.png": 105,
	"./virtual-bg7.png": 106,
	"./virtual-bg8.png": 107,
	"./virtual-bg9.png": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;